import React, { FC, ImgHTMLAttributes } from 'react';

import PlaceholderImage from '~assets/images/placeholder-image.webp';

const Image: FC<ImgHTMLAttributes<HTMLImageElement>> = ({
    src,
    width = 100,
    height = 100,
    ...props
}) => {
    return (
        <img
            src={src}
            width={width}
            height={height}
            onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = PlaceholderImage;
            }}
            {...props}
        />
    );
};

export default Image;
